import styled from 'styled-components';
import { mediaQuery } from '../../utils/styles';

export const Wrapper = styled.section`
  --countdown-bg-color: #1c1c1c;
  --countdown-text-color: #ffffff;

  background-color: var(--countdown-bg-color);
  color: var(--countdown-text-color);
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;

  .container {
    padding-left: 0;
    padding-right: 0;
  }

  .row {
    row-gap: 10px;
    justify-content: center;
  }

  .offers_countdown-timer,
  .offers_countdown-body {
    @media ${mediaQuery.mobileTablet} {
      margin-bottom: 0;
    }
  }

  .offers_countdown-body {
    padding-bottom: 0 !important;
    font-family: var(--t-font-family);
  }

  .offers_countdown-timer [aria-hidden='true'] p {
    font-family: var(--t-font-family);
  }

  .offers_countdown_digit {
    font-size: 22px !important;
  }

  [data-testid='web-ui-kit-MTimer-skeleton'] [aria-hidden='true'] > div > div:first-child {
    font-size: 22px !important;
    min-block-size: 22px !important;
  }

  [data-testid='web-ui-kit-MTimer-skeleton'] [aria-hidden='true'] > div > div:first-child .react-loading-skeleton {
    width: 22px !important;
    height: 22px !important;
  }

  @media (min-width: 992px) {
    .row {
      justify-content: space-between;
      row-gap: 0;
    }

    .offers_countdown-body {
      text-align: right !important;
    }
  }

  @media (min-width: 1200px) {
    .container {
      max-width: 1140px;
    }
  }

  @media (min-width: 1440px) {
    padding-left: 150px;
    padding-right: 150px;
  }

  /* Force white text for all child elements */
  *,
  p,
  span,
  div,
  a,
  button {
    color: var(--countdown-text-color) !important;
  }

  /* Ensure button inherits white color */
  a *,
  button * {
    color: var(--countdown-text-color) !important;
  }
`;
